/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Justify } from 'ksnm-common-ui/lib/Table2/Table.interface';
import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { CellValue, ColumnInterface, RenderParam } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { logsStore } from '@stores/logsStore';

import { Status } from './Status';

import styles from './Logs.module.scss';

export const getLogsColumns = (fullSize: boolean): ColumnInterface[] => [
  {
    title: 'Описание действия',
    key: 'operation_description',
    width: fullSize ? undefined : 540,
    render: ({ data, value }) => (
      <div className={styles.status}>
        <Status titleStatus="" result={data.type_res as string} gap={8} />
        <span className={styles.value}>{value}</span>
      </div>
    ),
  },
  {
    title: 'Дополнительный комментарий',
    key: 'result_description',
    width: fullSize ? undefined : 540,
  },
  {
    title: 'Время старта',
    key: 'start_date',
    width: fullSize ? undefined : 240,
    orderBy: {
      isNullsFirst: false,
      type: ORDER.ASC,
      order: 1,
    },
  },
  {
    key: 'type_res',
    hidden: true,
  },
];

export const getColumns = (isExportFNS = false): ColumnInterface[] => [
  {
    title: 'Организация',
    key: 'organization_code',
    width: 230,
    render: ({ data, value }) => (
      <div className={styles.status}>
        <Status titleStatus="" result={data.type_res as string} gap={8} />
        <span className={styles.value}>{value}</span>
      </div>
    ),
  },
  {
    title: 'Код пакета',
    key: 'report_package_code_cm',
    width: 250,
    render: ({ value, data }: RenderParam): CellValue => {
      let exportFNS: string = '';
      let reportVersions: string = '';
      let controlVersions: string = '';

      const jsonObjects = Array.isArray(data?.json_objects) ? data.json_objects : [];

      if (isExportFNS) {
        exportFNS = jsonObjects
          .map((item) =>
            [
              item.year && `Год ${item.year}.`,
              item.period_id && `Период ${item.period_id}.`,
              `Версия ${item.version_number ?? 0}.`,
            ]
              .filter(Boolean)
              .join(' '),
          )
          .filter(Boolean)
          .sort()
          .join('\n');
      } else {
        reportVersions = jsonObjects
          .map((item) => item.reportVersionCode)
          .filter(Boolean)
          .join(', ');

        controlVersions =
          typeof data.json_objects === 'object' && (data.json_objects as any)?.ctrl_vers_code?.join(', ');
      }

      const tooltipContent = isExportFNS ? exportFNS : reportVersions || controlVersions;

      return (
        <div className={styles.package}>
          {tooltipContent && (
            <Tooltip content={tooltipContent} placement="auto" className={styles.tooltip}>
              <div
                onClick={(e) => {
                  e.stopPropagation();

                  logsStore.setAdditionalOptions({
                    guid: (data.guid as string) ?? '',
                    reportPackageCode: (value as string) ?? '',
                    reportVersions,
                    controlVersions,
                    exportFNS,
                  });
                }}
              >
                <Icon name="info" />
              </div>
            </Tooltip>
          )}
          {value}
        </div>
      );
    },
  },
  {
    title: 'Время старта',
    key: 'start_date',
    width: 230,
    orderBy: {
      isNullsFirst: false,
      type: ORDER.DESC,
      order: 1,
    },
  },
  {
    title: 'Время окончания',
    key: 'end_date',
    width: 230,
  },
  {
    title: 'Статистика данных (успех | провал)',
    key: 'count_data_out',
    width: 220,
    justify: Justify.CENTER,
    render: ({ value }) => <div className={styles.statistic}>{value}</div>,
  },
  {
    title: 'Статистика сообщений (успех | предупреждение | ошибка)',
    key: 'count_mes_out',
    width: 270,
    justify: Justify.CENTER,
    render: ({ value }) => <div className={styles.statistic}>{value}</div>,
  },
  {
    title: 'Результат',
    key: 'result',
    width: 230,
  },
  {
    title: 'Идентификатор процесса',
    key: 'guid',
    width: 230,
  },
  {
    title: 'Пользователь',
    key: 'username',
    width: 230,
  },
  {
    key: 'type_res',
    hidden: true,
  },
  {
    key: 'json_objects',
    hidden: true,
  },
];
